import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Wrench } from "@phosphor-icons/react";
import PageHeader from "@/components/PageHeader";
import { EQUIPMENT } from "@/lib/siteData";

export default function Equipment() {
  return (
    <div data-testid="equipment-page">
      <PageHeader
        eyebrow="— Equipment"
        title="Modern fleet. Maintained on-site. Ready when you are."
        intro="From 5-tonne diggers for tight residential sites to 20-tonne excavators for bulk earthworks, the right gear shows up to your job."
      />

      <section className="section-pad bg-[#F6F5F2]">
        <div className="container-fz grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#D2D0C9] border border-[#D2D0C9]">
          {EQUIPMENT.map((e, i) => (
            <motion.article
              key={e.name}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.04 }}
              data-testid={`equipment-card-${i}`}
              className="bg-[#F6F5F2] hover:bg-white p-8 md:p-10 transition-colors group"
            >
              <div className="flex items-center justify-between">
                <span className="num-marker">0{i + 1}</span>
                <Wrench
                  size={22}
                  weight="duotone"
                  className="text-[#D05322] group-hover:rotate-6 transition-transform"
                />
              </div>
              <h3 className="mt-6 font-display text-2xl text-stone-900 leading-tight">
                {e.name}
              </h3>
              <p className="mt-3 text-xs uppercase tracking-[0.2em] text-[#D05322] font-bold">
                {e.role}
              </p>
              <p className="mt-5 text-stone-600 leading-relaxed">{e.detail}</p>
            </motion.article>
          ))}
        </div>

        <div className="container-fz mt-16 border-t border-[#D2D0C9] pt-12 flex flex-col md:flex-row gap-6 md:items-center md:justify-between">
          <div>
            <p className="eyebrow mb-3">Need something specific?</p>
            <h3 className="font-display text-2xl md:text-3xl text-stone-900 max-w-xl">
              We've got connections across the region for specialist gear.
            </h3>
          </div>
          <Link to="/contact" data-testid="equipment-contact-link" className="btn-primary">
            Discuss your job <ArrowRight size={16} weight="bold" />
          </Link>
        </div>
      </section>
    </div>
  );
}
